import { render, staticRenderFns } from "./viewProgramaModules.vue?vue&type=template&id=a12815ba&scoped=true"
import script from "./viewProgramaModules.vue?vue&type=script&lang=js"
export * from "./viewProgramaModules.vue?vue&type=script&lang=js"
import style0 from "./viewProgramaModules.vue?vue&type=style&index=0&id=a12815ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12815ba",
  null
  
)

export default component.exports